const ALLOWED_PATHS = ["status", "automation", "alerts", "tasks", "metering", "trends", "reports", "savings", "occupancy"];

const APP_DEFAULT_HOME_PAGE_PATH = "status";

export { ALLOWED_PATHS, APP_DEFAULT_HOME_PAGE_PATH };